import type { SortDirection } from "../BookExtracts/types";
import "./SortIcon.scss";

interface SortIconProps {
  direction: SortDirection | null;
  single?: boolean;
}

// Double chevron = sortable but not active; a single chevron shows the
// active direction. `single` renders one chevron for the compact mobile chips.
function SortIcon({ direction, single = false }: SortIconProps) {
  if (single) {
    return (
      <svg
        className="sort-icon"
        viewBox="0 0 16 16"
        width="12"
        height="12"
        aria-hidden="true"
        focusable="false"
      >
        <path
          className="sort-icon__chevron sort-icon__chevron--active"
          d={direction === "asc" ? "M4 10l4-4 4 4" : "M4 6l4 4 4-4"}
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg
      className="sort-icon"
      viewBox="0 0 16 16"
      width="12"
      height="14"
      aria-hidden="true"
      focusable="false"
    >
      <path
        className={`sort-icon__chevron${
          direction === "asc" ? " sort-icon__chevron--active" : ""
        }`}
        d="M4 6.5l4-4 4 4"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className={`sort-icon__chevron${
          direction === "desc" ? " sort-icon__chevron--active" : ""
        }`}
        d="M4 9.5l4 4 4-4"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SortIcon;
